export default function fetchCountry(country) {
  return {
    type: "FETCH_COUNTRY",
    country
  };
}
